<template>
    <div class="solutionNavigationClass">
        <el-drawer
            :visible.sync="drawer"
            direction="ttb"
            :show-close="false"
            @close="closeSolutionNavigation"
            size="482px">
            <div style="width: 100%;height: 100%;" @mouseleave="solutionNavigationMouseleave">
                <div class="solutionNavigationContent">
                    <!-- <div class="closeDrawer" @click="closeDrawer">
                                <i class="el-icon-close"></i>
                            </div> -->
                    <div class="solutionNavigationLeft">
                        <el-input
                            placeholder="搜索解决方案"
                            suffix-icon="el-icon-search"
                            clearable
                            v-model="solutionInput"
                            @change="getSolutionKeydown()"
                        >
                        </el-input>
                        <div class="leftBlist">
                            <p
                                v-for="(items, index) in solutionList"
                                :key="index"
                                @mouseenter="handSolutionNapT(index)"
                                @mouseleave="handmouseover(index)"
                                :class="solutionNapIndex == index ? 'acitve_p1' : ''"
                            >
                                {{ items.name }}
                                <span
                                    class="acitve_p_bottom"
                                    :class="solutionNapIndex == index ? 'acitve_p' : 'normal_p'"
                                ></span>
                            </p>
                        </div>
                        <h5 @click="getAllSulution">查看所有解决方案 ></h5>
                    </div>
                    <div class="solutionNavigationRight" v-if="solutionMessage.length != 0">
                        <!-- v-show="solutionNapIndex == index" -->

                        <div
                            class="solutionNavigationRightBox"
                            v-for="(items, index) in solutionMessage"
                            :key="index"
                            @click="handsolutionDetails(items.uuid)"
                        >
                            <h6>{{ items.name }}</h6>
                            <p>
                                {{ items.description }}
                            </p>
                        </div>
                    </div>
                    <div v-else class="suluBottomBig2">
						<!-- 暂无数据 -->
						<img src="../../assets/nosearchMesg.jpg" style="width: 200px;" >
					</div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
    import {getProgramList, getSolutionList} from "../../utils/interface";
    import {mapState} from "vuex";

    export default {
        name: "solutionNavigation",
        data() {
            return {
                drawer: false,
                solutionInput: "",
                solutionList: [],
                solutionMessage: [],
                survival: "ENABLE", // 状态(ENABLE:启用;DISABLE:停用;VERIFY:验证中;)
                setIn: null,
                solutionNapIndex: "0",
                // 列表页
                status: "RELEASE", // 状态(HIDE:隐藏;DRAFT:草稿;RELEASE:发布;)
                programUuid: "",
                programName: "",
                current: "",
                pageSize: "",
            };
        },
        created() {
            this.setIn = setInterval(() => {
                if (this.isTokenDoor === true) {
                    clearInterval(this.setIn);
                    this.getProgramList();
                    // this.getSolutionList();
                }
            }, 500);
        },
        computed: {
            ...mapState({
                isTokenDoor: "isTokenDoor",
            }),
        },
        methods: {
            init(flag) {
                this.drawer = flag;
            },
            // 关闭弹出框
            // closeDrawer(){
            //     this.drawer = false
            //     this.$emit('closeDrawer')
            // }
            // 解决方案类别
            getProgramList() {
                let params = {
                    name: "",
                    survival: this.survival,
                    current: 1,
                    pageSize: 10,
                  type: 'PLAN',
                };
                getProgramList(params).then((res) => {
                    if (res.success) {
                        this.solutionList = res.data;
                        this.programUuid = this.solutionList[0].uuid;
                        this.getSolutionList();
                        // console.log("878888", res.data);
                    }
                });
            },
            // 解决方案列表页
            getSolutionList() {
                let params2 = {
                    // 搜索
                    name: "",
                    type: 'PLAN',
                    status: this.status,
                    programUuid: this.programUuid,
                    programName: this.programName,
                    current: this.current,
                    pageSize: this.pageSize,
                };
                getSolutionList(params2).then((res) => {
                    if (res.success) {
                        this.solutionMessage = res.data;
                        // console.log("9999", res.data);
                        // this.total = res.total;
                    }
                });
            },
            // 点击跳转相应的详情页
            handsolutionDetails(uuid) {
                let routeData = this.$router.resolve({
                    name: "caseDetails",
                    params: {uuid: uuid},
                });
                window.open(routeData.href, "_blank");
            },
            // 搜索的回车事件
            getSolutionKeydown() {
                let routeData = this.$router.resolve({
                    path: "/solution",
                    query: {solutionInput: this.solutionInput} || {},
                });
                window.open(routeData.href, "_blank");
                console.log("keydown", solution);
            },
            // 关闭弹窗、传参
            closeSolutionNavigation() {
                this.drawer = false;
                this.$emit("closeSolutionNavigation");
            },
            // 移动得到信息
            handSolutionNapT(i) {
                // console.log(111, i);
                this.solutionNapIndex = i;
                this.programUuid = this.solutionList[this.solutionNapIndex].uuid;
                this.getSolutionList();
            },
            // 鼠标移出
            handmouseover(i) {
                // console.log("移出");
                this.solutionNapIndex = i;
            },
            getAllSulution() {
                let routeData = this.$router.resolve({
                    name: "solution",
                });
                window.open(routeData.href, "_blank");
            },
            solutionNavigationMouseleave() {
                this.drawer = false
            }
        },
    };
</script>

<style scoped lang="less">
    .solutionNavigationClass {
        // font-family: "PingFangSC-Regular", sans-serif;
        /deep/ #el-drawer__title {
            display: none !important;
        }

        /deep/ .el-drawer__wrapper {
            top: 80px;
            margin: 0 5%;

            /deep/ .el-drawer {
                max-height: 80%;
                min-height: 50%;
            }
        }

        .solutionNavigationContent {
            min-width: 45%;
            max-width: 1200px;
            margin: 0 auto;
            display: flex;
            height: 100%;
            /* // position: relative;
            // .closeDrawer {
            //   position: absolute;
            //   right: 10px;
            //   top: 5px;
            //   font-size: 25px;
            //   cursor: pointer;
            //   color: #9a9797;
            //   &:hover {
            //     color: #000;
            //   }
            // } */

            .solutionNavigationLeft {
                width: 234px;
                background: #fbfbfb;
                height: 100%;
                // border-right: 1px solid #eee;
                font-size: 15px;
                color: #575d6c;
                flex-shrink: 0;
                padding: 20px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                align-items: flex-start;

                /deep/ .el-input {
                    margin-bottom: 15px;
                    // width: 77%;
                    input {
                        border: none;
                        border-bottom: 1px solid #efefef;
                        padding-left: 0;
                        background: none;
                    }
                }

                .leftBlist {
                    margin: 0 auto;
                }

                p {
                    font-size: 14px;
                    // font-family: "PingFangSC-Regular", sans-serif;
                    margin-top: 16px;
                    cursor: pointer;
                    padding-bottom: 2px;
                    border-bottom: 2px solid #d6000000;
                }

                .acitve_p1 {
                    color: #009999;
                    font-weight: bold;
                }

                .acitve_p {
                    width: 100%;
                }

                .normal_p {
                    width: 0%;
                }

                .acitve_p_bottom {
                    height: 2px;
                    background: #009999;
                    transition: width 1s;
                    display: block;
                }

                h5 {
                    // font-family: "PingFangSC-Regular", sans-serif;
                    font-size: 12px;
                    margin-top: 55px;
                    cursor: pointer;
                    width: 100%;
                    text-align: right;
                    font-weight: bold;
                }
            }

            .solutionNavigationRight {
                width: 70%;
                display: flex;
                flex-wrap: wrap;
                margin: 0 80px;
                overflow: auto;
                align-content: flex-start;
                height: 378px;

                .solutionNavigationRightBox {
                    margin-top: 59px;
                    width: 39%;
                    cursor: pointer;

                    &:nth-of-type(odd) {
                        margin-right: 160px;
                    }

                    h6 {
                        // font-family: "PingFangSC-Regular", sans-serif;
                        // width: 85%;
                        font-size: 16px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    p {
                        // font-family: "PingFangSC-Regular", sans-serif;
                        color: #afafaf;
                        font-size: 12px;
                        margin-top: 5px;
                        line-height: 20px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                    }
                }

                &::-webkit-scrollbar {
                    /*滚动条整体样式*/
                    width: 7px; /*高宽分别对应横竖滚动条的尺寸*/
                    height: 1px;
                }

                &::-webkit-scrollbar-thumb {
                    /*滚动条里面小方块*/
                    border-radius: 10px;
                    // -webkit-box-shadow: inset 0 0 5px rgba(145, 145, 145, 0.2);
                    background: #f5f5f5;
                }

                &::-webkit-scrollbar-track {
                    /*滚动条里面轨道*/
                    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
                    border-radius: 10px;
                    background: #fff;
                }
            }

            .suluBottomBig2 {
                margin-left: 28px;
                width: 70%;
                text-align: center;
                font-size: 30px;
                font-weight: bold;
                color: #d4d4d4;
                line-height: 650%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/header/solutionNavigation.vue